<template>
<div>
    <div class="body intro" id="login-main">
        <div class="wrap">
            <h1 class="mb-20"><img v-if="logo !== ''" :src="logo" alt="company logo"></h1>
            <!-- <div class="txt-center">
                <h2>{{title}}</h2>
            </div> -->
            <div class="box-password">
                <div class="password-box">
                    <div v-if="validCheck === 'Y'" class="password-con">
                        <h3 v-if="code === 'l'">계정 확인이 완료되었습니다.</h3>
                        <p v-if="code === 'l'" class="font-13">
                            비밀번호 재설정 후 다시 로그인해 주세요. <br>
                            비밀번호는 영문 + 숫자포함 8자 이상 12자 이하로 입력해 주세요.
                        </p>
                        <div class="login-input">
                            <label for="" class="dp-block">
                                <input type="text" v-model="email" class="w-100per mb-10" :placeholder="email" disabled>
                            </label>
                            <label for="" class="dp-block">
                                <input type="password" v-model="password" placeholder="비밀번호를 입력해 주세요." class="w-100per mb-10">
                            </label>
                            <!-- 입력오류 시 노출 -->
                            <!-- <p class="txt-red">비밀번호는 6자 이상 12자 이하로 입력해 주세요.</p> -->
                            <button @click="fixAdminPW()">비밀번호 재설정하기</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    EmptyCheck,
    EmailFormatCheck
} from '@/utils/validation.js'
export default {
    data: () => ({
        email: '',
        password: '',

        isLockModalOpened: false, // 계정잠금 팝업 on/off
        isValidAuth: true, //  이메일, 비밀번호가 유효한지 여부

        validCheck: 'Y',
        pageIdx : -1,
        isSend: false,
        code: 'p',
    }),

    watch: {
        tabType() {
            this.reset()
        }
    },

    mounted() {
        // if (sessionStorage.getItem('fixPWEmail')) {
        //     this.email = sessionStorage.getItem('fixPWEmail')
        // } else {
        //     alert('제대로 된 경로로 진입하지 않아\n로그인 화면으로 돌아갑니다')
        //     this.$router.push('/user/login')
        // }

        this.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
        this.axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET,PUT,POST,DELETE,OPTIONS'
        this.axios.defaults.headers.common['Access-Control-Allow-Headers'] = 'Content-Type, Authorization, Content-Length, X-Requested-With'
        // TODO: companyCode는 db itm_sugang_main 테이블에 company_code 참조 추후에 매핑필요
/* 
        var companyCode = 'ehddkeo'

        console.log('this.$route.params', this.$route.params)

        if (localStorage.getItem('companyCode')) {
            companyCode = localStorage.getItem('companyCode')
            sessionStorage.setItem('companyCode', companyCode)
        } else {
            alert('세션이 만료되었으므로 로그인 페이지로 이동합니다.')
        } */
        

        this.email = this.$route.params.email.substr(0, this.$route.params.email.indexOf("/"))
        this.pageIdx = this.$route.params.email.substring(this.$route.params.email.indexOf("^")+1)
        this.code = this.$route.params.code
        
        let passwordResetKey = this.$route.params.email
        let params = {
            passwordResetKey: passwordResetKey
        }

        this.axios.get(this.axios.root + this.axios.port + `/admin/password-key`, {
            params: params })
            .then(res => {
                console.log('res', res)
                if (res.data.err === 0) {
                    this.validCheck = 'Y'
                } else {
                    alert("유효시간이 만료되어 접근할 수 없습니다.");
                    this.email = ''
                    this.validCheck = 'N'
                    this.$router.push('/admin/login')
                }
            })
        
    },

    methods: {

        fixAdminPW() {

            if (this.password.trim() === '') {
                alert('비밀번호를 입력하세요.')
                return false
            }

            var passRegex = /^[A-Za-z0-9+]{8,12}$/
            if (!passRegex.exec(this.password)) {
                alert('비밀번호 형식은 영문 + 숫자포함 8~12자리로 해주세요.\n※ 특수문자 불가')
                return false
            }

            // if (this.password.length < 6 || this.password.length > 12) {
            //     alert('비밀번호는 영어+숫자 6자 이상 12자 이하로 입력해 주세요.')
            //     return false
            // }

            var params = new URLSearchParams()

            params.append('id', this.email)
            params.append('newPassword', this.password)
            // var params = {
            //     id: this.email,
            //     newPassword: this.password
            // }

            this.axios.put(this.axios.root + this.axios.port + '/admin/password-reset', params)
                // this.axios.put(this.axios.root + this.axios.port + '/user/password-reset', {
                //         params: params
                //     })
                .then(res => {
                    console.log('res', res)
                    if (res.data.err === 0) {
                        alert('비밀번호가 변경되었습니다.\n로그인 페이지로 이동합니다.')
                        this.$router.push('/admin/login')
                    } else {
                        alert(res.data.result)
                    }
                }).catch(err => {
                    console.log(err)
                    alert(err)
                })
        },
        // 탭 변경시 입력값 초기화
        reset() {
            this.email = ''
            this.accessCode = ''
            this.password = ''
        },

    }
}
</script>
